import { render, staticRenderFns } from "./RomaTipTap.vue?vue&type=template&id=133170c2&"
import script from "./RomaTipTap.vue?vue&type=script&lang=js&"
export * from "./RomaTipTap.vue?vue&type=script&lang=js&"
import style0 from "./RomaTipTap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports